/**
 * The initial value of the @@toStringTag property is the String value "Map".
 * https://tc39.es/ecma262/#sec-map.prototype-@@tostringtag
 */
export const mapPrototypeSymbolToStringTag = "Map";
